import axios from "axios";

export function getCurrencyList() {
  return axios.get(process.env.VUE_APP_API_URL + "sso/currencies");
}
